import SearchBarWrapper from "./SearchBarWrapper";

export default SearchBarWrapper;
